<template>
  <svg xmlns="http://www.w3.org/2000/svg" class="icon" viewBox="0 0 24 24">
    <path
      d="M13.3645 3.64553C10.9772 3.63907 8.96476 5.22731 8.37287 7.39015C8.34656 7.48699 8.25449 7.55801 8.15584 7.55801H6.99179C5.15036 7.55801 3.66406 8.96547 3.66406 10.7022V13.2976C3.66406 15.0343 5.15694 16.4418 6.99179 16.4418H8.15584C8.26107 16.4418 8.34656 16.5128 8.37287 16.6097C8.96476 18.7725 10.9706 20.3607 13.3645 20.3543C13.6078 20.3543 13.7919 20.1541 13.7919 19.9217C13.7919 17.6104 13.7919 6.39589 13.7919 4.08455C13.7919 3.84567 13.6423 3.64553 13.4055 3.64553L13.3645 3.64553Z"
    />
    <path
      d="M16.1133 9.09473C16.1133 9.09473 18.8425 11.3415 16.1133 14.6342"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
      fill="none"
    />
    <path
      d="M18.3037 6.77686C18.3037 6.77686 22.8876 10.9024 18.3037 16.9454"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
      fill="none"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconSpeaker',
};
</script>

<style scoped>
.icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  fill: inherit;
  flex-shrink: 0;
}
</style>
